import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../../FirebaseConfig";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Pie } from "react-chartjs-2";

// Register the required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const PieChart = ({ eventName }) => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const submissionStatsRef = doc(
          db,
          `Events/${eventName}/Statistics`,
          "severityStats"
        );
        const submissionStatsDoc = await getDoc(submissionStatsRef);

        if (submissionStatsDoc.exists()) {
          const data = submissionStatsDoc.data();

          setChartData({
            labels: ["Low", "Medium", "High", "Critical"],
            datasets: [
              {
                data: [data.Low || 0, data.Medium || 0, data.High || 0, data.Critical || 0],
                backgroundColor: [
                  'rgba(75, 192, 192, 0.3)',
                  'rgba(255, 206, 86, 0.3)',
                  'rgba(54, 162, 235, 0.3)',
                  'rgba(255, 99, 132, 0.3)',
                ],
                borderColor: [
                  'rgba(75, 192, 192, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 99, 132, 1)',

                ],
                borderWidth: 1,
              },
            ],
          });
        } else {
          setError("No data available");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [eventName]);

  const options = {
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 20,
          usePointStyle: true,
          margin: 10,
          font: {
            size: 14,
          },
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) => `${tooltipItem.label}: ${tooltipItem.raw}`,
        },
      },
      datalabels: {
        display: false,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">Loading...</div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center h-64 text-red-500">
        {error}
      </div>
    );
  }

  return (
    <>
      <Pie data={chartData} options={options} />
    </>
  );
};

export default PieChart;
